import { SchemaSubDelay } from '@/__generated/es-api'
import { Delta } from '@/app/module/campaigns/types'

export const toDelay = (delay: Delta): SchemaSubDelay => ({
  at: delay.at,
  country: delay.country,
  dayOfWeek: delay.dayOfWeek as SchemaSubDelay['dayOfWeek'] | undefined,
  daysOfWeek: delay.daysOfWeek,
  relative: delay.relative as SchemaSubDelay['relative'] | undefined,
  time: delay.time,
  timezone: delay.timezone,
  unit: toDelayUnit(delay.unit),
  value: delay.value,
})

export const toDelayUnit = (unit: Delta['unit']): SchemaSubDelay['unit'] => {
  switch (unit) {
    case 'second':
    case 'minute':
    case 'hour':
    case 'day':
    case 'week':
    case 'month':
    case 'at':
      return unit
    default:
      return undefined
  }
}
